function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.symbol.description.js";
import "core-js/modules/es.array.is-array.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.symbol.iterator.js";
import "core-js/modules/es.array.iterator.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
import "core-js/modules/es.array.slice.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.array.from.js";
import "core-js/modules/es.regexp.exec.js";
import React, { useState } from 'react';
import { useId, CardLegacy, CardContent, Collapse, GRAY, IconButton } from '@applyboard/ui-components';
import Summary from "./Summary";
import Details from "./Details";
import { ArrowChevronStyled, CardContentWrapper, CardWrapper } from "./style";
export var RequirementCard = function RequirementCard(_ref) {
  var id = _ref.id,
    title = _ref.title,
    description = _ref.description,
    currentStage = _ref.currentStage,
    finalStage = _ref.finalStage,
    category = _ref.category,
    entityLevel = _ref.entityLevel,
    status = _ref.status,
    tags = _ref.tags,
    modifiedAttributes = _ref.modifiedAttributes,
    isEarlyAccess = _ref.isEarlyAccess;
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    expanded = _useState2[0],
    setExpanded = _useState2[1];
  var expandButtonId = useId();
  var collapsibleContentId = useId();
  return /*#__PURE__*/React.createElement(CardLegacy, {
    variant: "outlined",
    fullWidth: true
  }, /*#__PURE__*/React.createElement(CardWrapper, null, modifiedAttributes.length ? /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(ExpandButton, {
    onClick: function onClick() {
      setExpanded(!expanded);
    },
    expanded: expanded,
    title: title,
    id: expandButtonId,
    "aria-controls": collapsibleContentId
  })) : null, /*#__PURE__*/React.createElement(CardContentWrapper, null, /*#__PURE__*/React.createElement(CardContent, null, /*#__PURE__*/React.createElement(Summary, {
    id: id,
    title: title,
    description: description,
    currentStage: currentStage,
    finalStage: finalStage,
    category: category,
    entityLevel: entityLevel,
    status: status,
    tags: tags,
    isEarlyAccess: isEarlyAccess
  })), /*#__PURE__*/React.createElement(Collapse, {
    "in": expanded,
    timeout: "auto"
  }, /*#__PURE__*/React.createElement(CardContent, {
    id: collapsibleContentId,
    role: "region",
    "aria-labelledby": expandButtonId
  }, /*#__PURE__*/React.createElement(Details, {
    modifiedAttributes: modifiedAttributes,
    isEarlyAccess: isEarlyAccess
  }))))));
};
var ExpandButton = function ExpandButton(_ref2) {
  var onClick = _ref2.onClick,
    id = _ref2.id,
    expanded = _ref2.expanded,
    title = _ref2.title,
    ariaControls = _ref2['aria-controls'];
  return /*#__PURE__*/React.createElement(IconButton, {
    id: id,
    onClick: onClick,
    "aria-label": "Toggle Requirement ".concat(title, " Details"),
    "aria-expanded": expanded,
    "aria-controls": ariaControls
  }, /*#__PURE__*/React.createElement(ArrowChevronStyled, {
    expanded: expanded,
    fill: GRAY[10],
    "aria-hidden": true
  }));
};
RequirementCard.defaultProps = {
  modifiedAttributes: []
};